import { createRouter, createWebHistory } from "vue-router";
// import Home from '../views/Home.vue'
// import Main from "../views/Main.vue";
import MultistepMain from "../views/MultistepMain.vue";
import MainLoadingStyle from "../views/MainLoadingStyle.vue";
import Vlog from "../views/Vlog.vue";
import VlogHome from "@/components/vlog/containers/VlogHome.vue";
import VlogPlay from "@/components/vlog/containers/VlogVideoDetail.vue";
import VlogDetail from "@/components/vlog/containers/VlogDetail.vue";
import VlogSearchResults from "@/components/vlog/containers/VlogSearchResults.vue";
// import VlogEmpty from "@/components/vlog/containers/VlogEmpty.vue";
import store from "@/store/index.js";

const routes = [
	{
		path: "/home",
		name: "MainLoadingStyle",
		component: MainLoadingStyle,
	},
	{
		path: "/",
		name: "MultistepMain",
		component: MultistepMain,
	},
	{
		path: "/vlog",
		name: "Vlog",
		component: Vlog,
		// https://router.vuejs.org/zh/guide/essentials/nested-routes.html
		children: [
			{
				// 首页
				path: "",
				component: VlogHome,
			},
			{
				// 带分类id
				path: "t/:tabid",
				component: VlogHome,
				props: (route) => ({ initialTabID: route.tabid }),
			},
			// {
			// 	//
			// 	path: "video/:id",
			// 	component: VlogPlay,
			// 	props: route => ({ id: route.id}),
			// },
			{
				// 再多一级来处理，这样VlogPlay这一级就可以非复用组件形式
				path: "video",
				component: VlogDetail,
				children: [
					{
						// 带分类id
						path: ":id",
						component: VlogPlay,
						props: (route) => ({ id: route.id }),
					},
					// 不合法路径则返回到首页
				],
			},
			{
				// 搜索结果页，带keywords
				path: "search",
				component: VlogSearchResults,
				props: (route) => ({ query: route.query.keywords }),
			},
		],
	},
	// {
	//   path: '/home',
	//   name: 'Home',
	//   component: Home
	// },
	// {
	//   path: '/about',
	//   name: 'About',
	//   // route level code-splitting
	//   // this generates a separate chunk (about.[hash].js) for this route
	//   // which is lazy-loaded when the route is visited.
	//   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
	// }
];

const router = createRouter({
	history: createWebHistory("/g"),
	routes,
});

router.beforeEach((to, from) => {
	from;
	// console.log(to);

	if (to.matched?.length == 0) {
		// fallback
		if (to.fullPath?.startsWith("/vlog")) {
			return { path: "/vlog" };
		}
		else {
			return {path: "/"};
		}
	}
	return true;
});

router.afterEach((to, from) => {
	// console.log(to);

	if (to.fullPath != from.fullPath) {
		// console.log("sendToAnalytics: " + to.fullPath);
		sendToAnalytics(to, from);
	}
});

function sendToAnalytics(to, from) {
	to;
	// cleanup already added
	document
		.querySelectorAll("body > img[src^='https://wei.ltd.com/analyst']")
		.forEach(function(x) {
			x.remove();
		});

	// const route = router.resolve(to);
	// const absoluteURL = new URL(route.href, window.location.origin).href;
	// console.log(absoluteURL);
	// console.log(window._ga);
	// console.log(store.state.websiteId);

	const websiteId = store.state.websiteId;
	const fromURL = from.href?.length == 0 ? "" : new URL(from.href, window.location.origin).href;
	const toURL = to.href?.length == 0 ? "" : new URL(to.href, window.location.origin).href;
	// console.log(fromURL);
	// console.log(toURL);
// console.log(websiteId);
	if (
		websiteId > 0 &&
		(!(process.env.NODE_ENV == "development") || websiteId == 394210)
	) {
		// if (websiteId > 0) {
		const _ga = window._ga;

		// console.log(from);
		// console.log(to);
		
		// _ga.params.r = document.referrer;
		// _ga.params.h = window.location.href;
		_ga.params["r"] = fromURL;
		_ga.params["h"] = toURL;
		_ga.url = "https://wei.ltd.com/analyst";
		_ga.params["wi"] = "3";
		_ga.params["ui"] = "0";
		_ga.init(websiteId);
	}
}

export default router;
